export default function Navbar({}) {
  const navigation = [
    { name: "Hardware Integration", path: "#intigrate" },
    { name: "Industries", path: "#industry" }
  ];

  const onPress = (e) => {
    e.preventDefault();
    const targetId = e.currentTarget.href.split("#")[1];
    const target = window.document.getElementById(targetId);

    if (target) {
      const offset = 80; // Adjust this value as needed
      window.scrollTo({
        top: target.offsetTop - offset,
        behavior: "smooth"
      });
    }
  };

  return (
    <nav className="flex gap-4">
      {navigation.map(({ name, path }) =>
        <a
          onClick={(e) => onPress(e)}
          className={`rounded-md px-2 py-[6px] text-white font-normal hover:bg-[#635bff]/[.4]`}
          href={path}
          key={path}
          tabIndex={-1}
          data-to-scrollspy-id={path}
        >
          {name}
        </a>
      )}
    </nav>
  );
}
